import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/custom-terms/{id}/agree']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const agreeToCustomTerms = async ({
  id,
  customerSignatorName,
  customerSignature,
  deviceFingerprint,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.post(`/custom-terms/${id}/agree`, {
    customerSignatorName,
    customerSignature,
    deviceFingerprint,
  });
  return response.data;
};

export default agreeToCustomTerms;
